var e={icon:"styles_icon__4iGYG",picture:"styles_picture__xsJpg"};export{e as default};
